import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{staticClass:"mx-auto",staticStyle:{"margin-top":"20px"},attrs:{"width":"96%"}},[_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"col":"12"}},[(_vm.host === 'predixon.noisegrasp.com' || _vm.oidParam === 'publicis')?_c('iframe',{staticStyle:{"height":"70vh"},attrs:{"src":"https://noisegrasp.gitbook.io/predixon-documentation","width":"100%"}}):_c('iframe',{staticStyle:{"height":"70vh"},attrs:{"src":"https://noisegrasp.gitbook.io/ng_documentation","width":"100%"}})])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }